module.exports = __webpack_public_path__ + "static/hero2-ab12da2f04e90cb926b433a680d28c80.jpg";